import React from 'react';
import { parseRenderOptions } from './utils';
import classNames from 'classnames';

export const ToggleField = props => {
  const renderOptions = parseRenderOptions(props);
  const modifyLabel = renderOptions.custom.modifyLabel || 'Modify';
  const cancelLabel = renderOptions.custom.cancelLabel || 'Cancel';
  return (
    props.visible && (
      <button
        disabled={!props.enabled}
        type="button"
        className={classNames('btn btn-outline-primary btn--toggle', {
          'btn-sm': renderOptions.size === 'sm',
        })}
        onClick={() => props.onChange(!props.value)}
      >
        {props.value ? cancelLabel : modifyLabel}
      </button>
    )
  );
};
